import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

export default {
    namespaced: true,
    state: {
        users: [], // все пользователи, доступ только админа
        actualUser: [], // текущий пользователь
        usersKeys: [], // ключи пользователя, свойства
    },

    mutations: {
        SET_USERS(state, payload) {
            state.users = payload;
        },
        SET_ACTUAL_USER(state, payload) {
            state.actualUser = payload;
        },
        SET_USERS_KEYS(state, payload) {
            state.usersKeys = payload;
        },
    },

    actions: {
        async fetchUsers({ commit }) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/users/getAllUsers", config); // делаем запрос к API

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.user_id,
                            'Имя': obj.fullname,
                            'Email': obj.email,
                            'Права': obj.role_name
                        };
                    };
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_USERS', transformedData); // сохраняем данные в состояние
                commit('SET_USERS_KEYS', {
                    'Имя': "firstname",
                    'Фамилия': "lastname",
                    'Email': "email",
                    'Права': "roleName",
                    'Пароль': "hashPass"
                });
            } catch (error) {
                console.error(error);
            }
        },

        async fetchActualUser({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/users/getUser`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.user_id,
                            'email': obj.email,
                            'Имя': obj.fullname?.split(" ")[0],
                            'Фамилия': obj.fullname?.split(" ")[1],
                            'Роль': obj.role_name,
                            'Номер': obj.phone
                        };
                    };
                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ACTUAL_USER', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },
    }

}